module.exports = __webpack_public_path__ + "img/newlogo1.cdaec4a9.png";